import { CSSObject } from '@emotion/react'

export const container = (): CSSObject => ({
  position: 'relative',
})

export const loaderContainer = (): CSSObject => ({
  '@keyframes fade-in': {
    '0%': { opacity: 0 },
    '100%': { opacity: 0.7 },
  },
  animation: 'loader-fade-in 0.5s',
})

export const childContainer = (): CSSObject => ({
  '@keyframes fade-in': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
  animation: 'loader-fade-in 0.25s',
})
